import { useQuery } from '@tanstack/react-query';
import { Card, Modal, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { ReactComponent as Plus } from '../../../assets/add.svg';

import { getAdminUsers } from '../request';
import Button from '../../../custom/button/button';
import { useState } from 'react';
import AddAdminUser from './addAdminUser';
import { getErrorMessage } from '../../../utils/getErrorMessage';

const AdminUsers = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['get-admin-users'],
    queryFn: getAdminUsers,
  });

  const toggleAddModal = () => setOpenAdd((prev) => !prev);
  const toggleEditModal = () => setOpenEdit((prev) => !prev);

  const columns: ColumnsType<AdminUser> = [
    {
      key: 'S/N',
      title: 'S/N',
      render: (_text, _record, index) => index + 1,
    },
    {
      key: 'appNo',
      title: 'User ID',
      dataIndex: 'applicantId',
    },
    {
      key: 'firstName',
      title: 'First Name',
      dataIndex: 'firstName',
    },
    {
      key: 'lastName',
      title: 'Last Name',
      dataIndex: 'lastName',
    },
    {
      key: 'email',
      title: 'Email',
      dataIndex: 'email',
    },
    {
      key: 'phoneNo',
      title: 'Phone Number',
      dataIndex: 'phoneNumber',
    },
    {
      key: 'role',
      title: 'Role',
      render: (_text, record) => record?.roleList?.roles?.map((role) => role).join(', '),
    },
  ];

  const userData = data as AdminUser[];

  return (
    <div>
      <section className="space-between">
        <h3>Admin Users</h3>
        <Button text="Add User" iconBefore={<Plus />} onClick={toggleAddModal} />
      </section>

      <br />

      <Card bordered={false}>
        <Table
          dataSource={userData}
          columns={columns}
          rowKey={(record) => record.applicantId}
          scroll={{ x: true }}
          loading={isLoading}
          pagination={false}
          locale={{ emptyText: isError ? getErrorMessage(error) : 'No admin users found' }}
        />
      </Card>

      <Modal title="Add Admin User" open={openAdd} onCancel={toggleAddModal} footer={null}>
        <AddAdminUser handleClose={toggleAddModal} refetch={refetch} />
      </Modal>

      <Modal title="Edit Admin User" open={openEdit} onCancel={toggleEditModal} footer={null}>
        <p>Edit Admin User Modal Content</p>
      </Modal>
    </div>
  );
};

export default AdminUsers;
